import notifications from "../models/notifications";

export const types = {
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
};

export const actions = {
  addNotifications: ({ data, api }) => {
    return { type: types.ADD_NOTIFICATION, value: { data, api } };
  },
  removeNotifications: (payload) => {
    return { type: types.REMOVE_NOTIFICATION, value: { data: payload } };
  },
};

export default function reducer(state = notifications, action) {
  switch (action.type) {
    case types.SET_NOTIFICATIONS:
      return action.value;
    default:
      return state;
  }
}
